/**
 * Generates a random ID using the same algorithm as Firestore's auto-generated document IDs.
 * @see https://github.com/googleapis/nodejs-firestore/blob/main/dev/src/util.ts
 */
export function autoId(length = 20): string {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const maxValue = 62 * 4 - 1;

  let result = "";
  while (result.length < length) {
    const bytes = crypto.getRandomValues(new Uint8Array(40));
    for (let i = 0; i < bytes.length && result.length < length; i++) {
      if (bytes[i] <= maxValue) {
        result += chars.charAt(bytes[i] % 62);
      }
    }
  }

  return result;
}
